import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";

export interface IAuditLog {
  id: string;
  entityName: string;
  entityId: string;
  action: string;
  changes: string | null;
  userId: string | null;
  timestamp: string;
}

interface IAuditLogResponse {
  success: boolean;
  message: string;
  data: IAuditLog[];
}

export default function useAuditLogs(entityName: string, entityId: string, componentName = "useAuditLogs") {
  const { get } = useApiHelper(apiConfig(componentName));

  const auditLogs = useQuery({
    queryKey: ["auditLogs", entityName, entityId],
    queryFn: () => get<IAuditLogResponse>(`/audit/${entityName}/${entityId}`),
    enabled: !!entityName && !!entityId,
  });

  return { auditLogs };
}
